export const THREADS_ACTION_ICON_PATHS: string[] = [
  'images/socialmedia/like-icon-threads.svg',
  'images/socialmedia/comment-icon-threads.svg',
  'images/socialmedia/repost-icon-threads.svg',
  'images/socialmedia/share-icon-threads.svg',
];

export const THREADS_FOLLOW_ICON_PATH = 'images/socialmedia/follow-icon-threads.svg';
